import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { useDeleteUserContact } from 'vendors/queries/useVendorQuery'
import { CircularProgress } from '@mui/material'
import { useSnackbar } from 'snackbar/SnackbarContext'
import { Navigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import DeleteUserContactDialogContent from 'vendors/components/vendorContact/dialogs/deleteUserContactDialog/DeleteUserContactDialogContent'
import DeleteYourContactDialogContent from 'vendors/components/vendorContact/dialogs/deleteUserContactDialog/DeleteYourContactDialogContent'

import { useTranslation } from 'react-i18next'

type DeleteUserContactDialogProps = {
  isOpen: boolean
  onClose: () => void
  vendorId: string
  contactId: string
  contactEmail: string
}

const DeleteUserContactDialog: React.FC<DeleteUserContactDialogProps> = ({
  isOpen,
  onClose,
  vendorId,
  contactId,
  contactEmail
}) => {
  const { t } = useTranslation()

  const { user } = useAuth0()
  const { mutate, isPending: isLoading, isError, isSuccess } = useDeleteUserContact(vendorId, contactId, contactEmail, user?.email)
  const { showSnackbar } = useSnackbar()

  const onDeleteClick = () => {
    mutate()
  }

  React.useEffect(() => {
    if (isSuccess) {
      showSnackbar(t('contact-deleted-successfully'))
      onClose()
    }
  }, [isSuccess, onClose, showSnackbar, t])

  if (isError) {
    return <Navigate to={`/error`} replace />
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {user?.email === contactEmail ? (
        <DeleteYourContactDialogContent />
      ) : (
        <DeleteUserContactDialogContent contactEmail={contactEmail} />
      )}
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button color="grey" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onDeleteClick}
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress sx={{ color: 'grey.500' }} size={16} /> : null}
        >
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteUserContactDialog
